import { isDefined } from "@clipboard-health/util-ts";
import { FormControl, FormHelperText, FormLabel, Stack } from "@mui/material";
import { Text, TextArea } from "@src/appV2/redesign/system/ui-components";
import { type Control, Controller, type UseFormWatch } from "react-hook-form";

import { type ExtendShiftFormValues } from "./extendShiftFormSchema";

const ADDITIONAL_DETAILS_MAX_LENGTH = 200;

interface ExtendShiftAdditionalDetailsFieldProps {
  control: Control<ExtendShiftFormValues>;
  watch: UseFormWatch<ExtendShiftFormValues>;
}

export function ExtendShiftAdditionalDetailsField(props: ExtendShiftAdditionalDetailsFieldProps) {
  const { control, watch } = props;

  const additionalDetailsLength = watch("additionalDetails")?.length ?? 0;
  const remainingCharacters = ADDITIONAL_DETAILS_MAX_LENGTH - additionalDetailsLength;

  return (
    <FormControl fullWidth>
      <FormLabel htmlFor="additionalDetails-input">
        <Text semibold variant="body2">
          Additional details (optional)
        </Text>
      </FormLabel>
      <Controller
        name="additionalDetails"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <TextArea
              {...field}
              id="additionalDetails-input"
              rows={4}
              placeholder="Anything you would like to add..."
            />
            <Stack
              direction="row"
              justifyContent={isDefined(fieldState.error) ? "space-between" : "flex-end"}
              sx={{ marginTop: 0.5 }}
            >
              {isDefined(fieldState.error) && (
                <FormHelperText error>{fieldState.error.message}</FormHelperText>
              )}
              <Text
                variant="caption"
                sx={{
                  color: (theme) =>
                    remainingCharacters < 0
                      ? theme.palette.error.main
                      : theme.palette.text.secondary,
                }}
              >
                {remainingCharacters} characters remaining
              </Text>
            </Stack>
          </>
        )}
      />
    </FormControl>
  );
}
